'use strict'

function _toConsumableArray(arr) {
	if (Array.isArray(arr)) {
		for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
			arr2[i] = arr[i]
		}
		return arr2
	} else {
		return Array.from(arr)
	}
}

///// calendary
document.addEventListener("DOMContentLoaded", () => {
	function eventDay() {
		var event = document.querySelectorAll('.fc-event-container')
		// let days = document.querySelectorAll(".fc-bg .fc-day");
		var newDiv = document.querySelector(
			'.block-fixed-block-contentminisite-one-calc-movil-descrip'
		)
		// var date = void 0;
		var para = document.createElement('ul')
		// const title = document.createElement("h2");
		// days.forEach((ed, ind) => {
		//   ed.onclick = function() {
		//     date = this.dataset.date;
		//   };
		// });
		if (event != null) {
			event.forEach(function (el, ind) {
				el.addEventListener('click', function (btn) {
					var context = btn.target
					var btnPos = Math.floor(context.getBoundingClientRect().left)
					// console.log(context);
					var contextTr = context.parentNode.parentNode
					var contextEvents = [].concat(
						_toConsumableArray(contextTr.querySelectorAll('.fc-event'))
					)
					para.innerHTML = ''
					var result = contextEvents.filter(function (ev) {
						return (
							Math.floor(ev.getBoundingClientRect().left) == btnPos ||
							Math.floor(ev.getBoundingClientRect().left) - btnPos == 1
						)
					})

					result.forEach(function (res) {
						console.log(res)
						// title.innerText = date;
						// if (!newDiv.querySelector("h2")) {
						//   newDiv.insertAdjacentElement("afterbegin", title);
						// }
						para.innerHTML +=
							'<li><a href=' + res + '>' + res.innerText + '</a></li>'
						newDiv.appendChild(para)
						newDiv.classList.add('event-active')
					})
				})
			})
		}

		//// delete of events

		Array.from(document.querySelectorAll('.fc-day ')).map(function (el, ind) {
			el.addEventListener('click', function () {
				var fcday = ind
				Array.from(
					document.querySelectorAll('.fc-content-skeleton tbody td ')
				).map(function (ella, ind1) {
					if (ella != null && fcday == ind1) {
						var clase = ella.classList.contains('fc-event-container')
						var container_ul = document.querySelector(
							'.block-fixed-block-contentminisite-one-calc-movil-descrip'
						)
						if (clase == false) {
							container_ul.classList.remove('event-active')
							container_ul.classList.add('ul-blank')
						}
					}
				})
			})
		})

		//// click js unido
		Array.from(document.querySelectorAll('.fc-day ')).map(function (el, ind) {
			el.addEventListener('click', function () {
				var fcday = ind
				Array.from(
					document.querySelectorAll('.fc-content-skeleton tbody td ')
				).map(function (ella, ind1) {
					if (ella != null && fcday == ind1) {
						var event = ella.classList.contains('fc-event-container')
						if (event == true) {
							ella.click()
						}
					}
				})
			})
		})
	}
	eventDay()

	/// funcionalidad fecha ///////

	function prueba() {
		var calendary = document.querySelector(
			'.block-views-blockminisitio-tipo-1-calendario-block-1'
		)
		var date_calendary = document.createElement('div')
		if (date_calendary != null && calendary != null) {
			date_calendary.classList.add('date-calendary')
			calendary.appendChild(date_calendary)
		}

		var text_initial = document.querySelector(
			'.block-fixed-block-contentminisite-one-calc-movil-descrip span'
		)
		var width_cal = window.innerWidth
		if (width_cal <= 1024 && calendary != null) {
			Array.from(document.querySelectorAll('.fc-day ')).map(function (el) {
				el.addEventListener('click', function () {
					var day = this.dataset.date
					var newDate = document.createElement('div')
					var newday = document.createTextNode(day)
					newDate.appendChild(newday)
					date_calendary.appendChild(newDate)
					text_initial.style.display = 'none'
				})
			})
		}

		// var indicador = document.createElement("div");
		// indicador.innerHTML = "<div><i></i> Indicador de inicio </div>";
		// indicador.classList.add("indicator");
		// calendary.appendChild(indicador);
		// var circle = document.querySelector(".indicator i");
		// circle.classList.add("fas fa-circle");
	}
	prueba()

	Array.from(document.querySelectorAll('.fc-left button')).map(function (but) {
		var width_but = window.innerWidth
		if (width_but <= 1024 && but != null) {
			but.addEventListener('click', function () {
				Array.from(
					document.querySelectorAll(
						'.block-views-blockminisitio-tipo-1-calendario-block-1 .date-calendary'
					)
				).map(function (ela) {
					var content_ul = document.querySelector(
						'.block-fixed-block-contentminisite-one-calc-movil-descrip'
					)
					content_ul.classList.remove('event-active')
					content_ul.classList.add('ul-blank')
					ela.style.display = 'none'
				})
				prueba()
				eventDay()
			})
		}
	})

	//// Dias de la semana - Calendario

	Array.from(document.querySelectorAll('.fc-day-header span')).map(function (
		pr
	) {
		var width_pr = window.innerWidth
		if (width_pr <= 1024 && pr != null) {
			var prueba2 = pr.innerText.substring(0, 1)
			var span = document.createElement('span')
			var newSpan = document.createTextNode(prueba2)
			span.appendChild(newSpan)
			pr.replaceWith(span)
		}
	})

	//acordeon documents ///////
	var accItem = document.getElementsByClassName('views-row-group')
	if (accItem != null && accItem != null) {
		var i = 0
		for (i = 0; i < accItem.length; i++) {
			accHD[i].addEventListener('click', toggleItem, false)
		}
	}
	
	 toggleItem = () => {
		//var itemClass = this.parentNode.className
		for (i = 0; i < accItem.length; i++) {
			accItem[i].className = 'views-row-group close'	
		}
		if (itemClass == 'views-row-group close') {
			this.className = 'views-row-group open' 
		}
	}

	//menu  organismos
	Array.from(document.querySelectorAll('.sub-menu-archdiocese-menu li .menu-organismos')).map(function (e) {
		if (e != null) {
			var navfooter = e.nextElementSibling
			if (navfooter != null) {
				e.addEventListener('mouseover', function () {
					navfooter.classList.add('show')
					e.classList.add('show')
				})
				e.addEventListener('mouseout', function () {
					navfooter.classList.remove('show')
					e.classList.remove('show')
				})
				navfooter.addEventListener('mouseover', function () {
					navfooter.classList.add('show')
					e.classList.add('show')
				})
				navfooter.addEventListener('mouseout', function () {
					navfooter.classList.remove('show')
					e.classList.remove('show')
				})
			}
		}
	})


	///// clase para eventos para preloader
	var pathname_title_event_center = window.location.pathname

	if (pathname_title_event_center == '/centro-de-informacion/eventos') {
		document.querySelector('body').classList.add('eventos-centrodeinformacion')
	}

	/// drop-down header menu plan E

	Array.from(
		document.querySelectorAll(
			'.header-minisite-three .main-menu-home-plane .father-menu-seab'
		)
	).map(function (e) {
		if (e != null) {
			var navsibli = e.nextElementSibling
			if (navsibli != null) {
				e.addEventListener('mouseover', function () {
					navsibli.classList.add('active')
					e.classList.add('active')
				})
				e.addEventListener('mouseout', function () {
					navsibli.classList.remove('active')
					e.classList.remove('active')
				})
				navsibli.addEventListener('mouseover', function () {
					navsibli.classList.add('active')
					e.classList.add('active')
				})
				navsibli.addEventListener('mouseout', function () {
					navsibli.classList.remove('active')
					e.classList.remove('active')
				})
			}
		}
	})
})

//# sourceMappingURL=drop_down.arquidiocesis.script.js.map
